var pauseNotifications = [];
var queueNotifications = [];

export const abbreviate = (text) => {
    var ret = text.split(' ').map(function (item) { return item[0] }).join('');

    ret = ret.substring(0, 2);

    return ret;
};

export const seconds2HMS = (s) => {
    var h = Math.floor(s / 3600); // Horas
    s -= h * 3600;
    var m = Math.floor(s / 60); // Minutos restantes
    s -= m * 60;
    var sH = h.toString().length === 1 ? "0" + h : h;
    return sH + ":" + (m < 10 ? '0' + m : m) + ":" + (s < 10 ? '0' + s : s);
};

export const seconds2MS = (s) => {
    var h = Math.floor(s / 3600); // Horas
    s -= h * 3600;
    var m = Math.floor(s / 60); // Minutos restantes
    s -= m * 60;
    return (m < 10 ? '0' + m : m) + ":" + (s < 10 ? '0' + s : s);
};

export const notify = (title, body, icon, type) => {

    let disabledNotifications = localStorage.getItem("faDisabledNotifications");
    let persistentNotifications = localStorage.getItem("faPersistentNotifications");

    if (disabledNotifications != null && disabledNotifications.indexOf(type) === -1) {

        let persist = persistentNotifications != null && persistentNotifications.indexOf(type) > -1
        let notification = new Notification(title, {
            body: body,
            icon: icon,
            requireInteraction: persist
        });

        if (type === "pause") {
            pauseNotifications.push(notification);
        }
        if (type === "queue") {
            queueNotifications.push(notification);
        }

        if (!persist) {
            notification.onshow = function () {
                setTimeout(function () {
                    notification.close();
                }, 5000);
            }
        }
    }
}

export const notifyWithAction = (title, body, icon, type, actions) => {
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.ready.then(function (registration) {
            let persistentNotifications = localStorage.getItem("faPersistentNotifications");
            let persist = persistentNotifications != null && persistentNotifications.indexOf(type) > -1
            registration.showNotification(title, {
                body: body,
                icon: icon,
                actions: actions,
                requireInteraction: persist
            });
        });
    }
}

export const removeNotification = (type) => {

    console.log("RemoveNotification type: " + type);

    if (type === "pause") {
        pauseNotifications.forEach(n => {
            n.close()
        });
        pauseNotifications = [];
    }
    if (type === "queue") {
        queueNotifications.forEach(n => {
            n.close()
        });
        queueNotifications = [];
    }
}